import React from 'react'
import SelectType from './SelectType';
import SelectStatus from './SelectStatus';
import SelectCategory from './SelectCategory';
import { AssetInterface } from '../../../../../models/AssetModel/Asset';

interface AssetSelectsProps {
    asset: AssetInterface;
    page: number;
    pageSize: number;
}

export const AssetSelects: React.FC<AssetSelectsProps> = ({ asset, page, pageSize }) => {
    return (
        <div className='ms-auto d-flex flex-column gap-1 me-5'>
            <SelectCategory
                asset={asset}
                categoryId={asset.assetCategoryId}
                page={page}
                pageSize={pageSize}
            />
            <SelectType
                asset={asset}
                typeId={asset.assetTypeId}
                page={page}
                pageSize={pageSize}
            />
            <SelectStatus
                asset={asset}
                statusId={asset.assetStatusId}
                page={page}
                pageSize={pageSize}
            />
        </div>
    );
}
export default AssetSelects